import styled from 'styled-components';

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;

  &:link,
  &:visited {
    text-decoration: none;
  }

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 767px) {
    justify-content: center;
  }
`;

export const LogoImage = styled.img`
  height: ${({ theme }) => theme.spacing[12]};
  width: ${({ theme }) => theme.spacing[12]};
  border-radius: ${({ theme }) => theme.radii.full};
`;

export const Title = styled.div`
  text-decoration: none;
  font-family: ${({ theme }) => theme.fonts.brand};
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.typeScale.h2.fontSize};
  margin-left: ${({ theme }) => theme.spacing[4]};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1;
  display: flex;

  @media (max-width: 767px) {
    font-size: ${({ theme }) => theme.typeScale.h3.fontSize};
  }
`;

export const TitleGreen = styled.span`
  color: ${({ theme }) => theme.colors.primary};
`;

export const TitleWhite = styled.span`
  color: ${({ theme }) => theme.colors.text};
`;
